/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import axios from 'axios'
import {
  Message,
} from 'element-ui'
import qs from 'qs'

import {
  getToken
} from '@/util/auth'
const cookieUser = getToken()
const userLoginInfo = {userId: cookieUser.userId,name: cookieUser.realName,orgId: cookieUser.organizationId,orgName: cookieUser.organizationName,roleId: cookieUser.roleIds,username: cookieUser.account}

// 创建axios实例
let baseURL = process.env.API_ROOT

let baseBackstageUrl = process.env.Backstage_ROOT

let basePatientUrl = process.env.Patient_ROOT //患者资料

let baseRepairURL = process.env.REPAIRAPI_ROOT
let baseFileURL = process.env.IMGAPI_ROOT
let baseFileViewURL = process.env.File_ROOT
let baseVideoViewURL = process.env.Video_ROOT
let baseWechatURL = process.env.Wechat_ROOT
let baseMeetURL = process.env.Meet_ROOT
let baseImUrl = process.env.IM_ROOT
let baseEMTUrl = process.env.EMTAPI_ROOT
let baseXINGJIUrl = process.env.XINGJIAPI_ROOT //星记
// respone拦截器
axios.interceptors.response.use(
  response => {
    if (response.status == '200' || response.status == 200) {
      return response
    } else {
      return Promise.reject('error')
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default (options, data) => {
  // var config = JSON.parse(localStorage.getItem('Config'));
  if (config) {
    baseURL = config.API_ROOT;
    baseRepairURL = config.REPAIRAPI_ROOT;
    baseFileURL = config.IMGAPI_ROOT;
    baseFileViewURL = config.File_ROOT;
    baseVideoViewURL = config.Video_ROOT;
    baseWechatURL = config.Wechat_ROOT;
    baseMeetURL = config.Meet_ROOT;
    baseBackstageUrl = config.Backstage_ROOT;
    basePatientUrl = config.Patient_ROOT; //患者资料
    baseImUrl = config.IM_ROOT;
    baseEMTUrl = config.EMTAPI_ROOT;
    baseXINGJIUrl = config.XINGJIAPI_ROOT;
  }


  let httpOptions = {
    url: baseURL + options.url,
    method: options.method,
    // 		headers: {
    // 			'Content-Type': 'application/json;charset=UTF-8'
    // 		},
    // get 请求时带的参数
    params: Object.assign(data),
    // post 请求的数据
    data: (options.isFormData == true || options.isJsonData) ? data : qs.stringify(data),
    // eslint-disable-next-line no-unused-vars
    onUploadProgress: function (progressEvent) {
      // 对原生进度事件的处理
    },
    // `onDownloadProgress` 允许为下载处理进度事件
    onDownloadProgress: function (progressEvent) {
      // 对原生进度事件的处理
    },
  }
  if (options.onUploadProgress != null) {
    httpOptions.onUploadProgress = options.onUploadProgress
  }
  // console.log(httpOptions.data);
  if (options.requestType == null) {
    httpOptions.url = baseURL + options.url
  } else {
    if (options.requestType == 1) {
      httpOptions.url = baseURL + options.url
    }
    // else if (options.requestType == 11) {
    //   httpOptions.url = baseBackstageUrl + options.url
    // }
    else if (options.requestType == 2) {
      httpOptions.url = baseRepairURL + options.url
    } else if (options.requestType == 3) {
      //上传接口
      httpOptions.url = baseFileURL + options.url
      console.log(httpOptions.url)
    } else if (options.requestType == 4) {
      //在线预览
      httpOptions.url = baseFileViewURL + options.url
      console.log(httpOptions.url)
    } else if (options.requestType == 5) {
      //在线视频
      httpOptions.url = baseVideoViewURL + "api/" + options.url
      console.log(httpOptions.url)
    } else if (options.requestType == 6) {
      httpOptions.url = baseWechatURL + options.url
    } else if (options.requestType == 7) {
      httpOptions.url = baseMeetURL + options.url
    } else if (options.requestType == 8) { //患者资料
      httpOptions.url = basePatientUrl + options.url
      // httpOptions.url =  options.url
      // console.log(httpOptions)
    } else if (options.requestType == 9) { //IM获取群组
      httpOptions.url = baseImUrl + options.url
    } else if (options.requestType == 11) { //急救基地
      httpOptions.url = baseEMTUrl + options.url
    } else if (options.requestType == 12) { //星记
      const info = JSON.stringify(userLoginInfo)
      const token = window.btoa(encodeURIComponent(JSON.stringify(info)))
      httpOptions.url = baseXINGJIUrl + options.url
      httpOptions.headers = {
        token: token
      }
    }
  }

  if (options.isFormData == true) {
    httpOptions.headers = {
      'Content-Type': 'multipart/form-data'
    }
  }
  // if (options.isJsonData) {
  // 	httpOptions.headers = {
  // 		'Content-Type': 'application/json;'
  // 	}
  // 	httpOptions.data = qs.parse(httpOptions.data)

  // }

  if (options.isJsonData) {
    httpOptions.headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }
  if (options.isJsonData && options.requestType == 12) {
    const info = JSON.stringify(userLoginInfo)
    const token = window.btoa(encodeURIComponent(JSON.stringify(info)))
    httpOptions.headers['token'] = token
  }

  if (options.responseType != '' && options.responseType != null) {
    httpOptions.responseType = arraybuffer
  }
  // 请求协议对应的方法
  if (options.method === 'GET' || options.isParams == true) {
    delete httpOptions.data
  } else {
    delete httpOptions.params

  }
  // post请求 参数拼接到url后面
  if (options.method === 'POST' && options.isParams == true) {
    delete httpOptions.data
  }
  return new Promise((resolve, reject) => {
    axios(httpOptions)
      .then(res => {
        resolve(res.data)
      })
      .catch(error => {
        //	catchErrorEvt(error)
        console.log(error)
        reject(error)
      })
  })
}